<template>
  <v-dialog :value="dialog" max-width="700" @click:outside="close" @keydown.esc="close">
    <v-card v-if="payslip">
      <v-card-title>
        <span class="headline">Historial del recibo</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <div v-if="loading" class="text-center py-10">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <v-timeline v-else dense>
          <v-timeline-item v-for="event in list" :key="event.id" small :color="event.event == 'voided' ? 'red' : 'primary'">
            <div class="d-flex justify-space-between">
              <b>{{ eventName(event.event) }}</b>
              <span class="grey--text">{{ formatDateTime(event.creation_date) }}</span>
            </div>
            <div>{{ event.user || "-" }}</div>
            <div v-if="event.event == 'signed' && event.data">
              {{ event.data.conformity == "disagree" ? "Disconforme" : "Conforme" }} · Código {{ event.data.verification_code }}
            </div>
            <div v-if="event.data && event.data.reason">Motivo: {{ event.data.reason }}</div>
            <div v-if="event.event == 'ai_read'">
              CUIL: {{ event.data.cuil || "no encontrado" }}<span v-if="event.data.employee_name"> · {{ event.data.employee_name }}</span><span
                v-if="event.data.employee_number"> · Legajo {{ event.data.employee_number }}</span>
            </div>
            <div v-if="event.data && event.data.replaces_id">Reemplaza al recibo #{{ event.data.replaces_id }}</div>
            <div v-if="event.data && event.data.batch_id">
              Lote #{{ event.data.batch_id }}, página {{ event.data.page_from }}<span
                v-if="event.data.page_to != event.data.page_from">-{{ event.data.page_to }}</span>
            </div>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { payslipService } from "@/libs/ws/payslipService";
import { PAYSLIP_EVENTS, formatDateTime } from "@/constants/payslips";

export default {
  props: {
    dialog: Boolean,
    payslip: Object,
  },
  data() {
    return {
      list: [],
      loading: false,
      formatDateTime: formatDateTime,
    };
  },
  watch: {
    dialog(value) {
      if (value) this.load();
    },
  },
  methods: {
    eventName(event) {
      return PAYSLIP_EVENTS[event] || event;
    },
    load() {
      this.list = [];
      this.loading = true;
      payslipService
        .events(this.payslip.id)
        .then((response) => {
          if (response.status) this.list = response.result;
          else this.$toast.error(response.msg, "Error");
        })
        .catch((e) => console.log(e))
        .finally(() => (this.loading = false));
    },
    close() {
      this.$emit("updateDialog", false);
    },
  },
};
</script>
